import { render, staticRenderFns } from "./DemandsTable.vue?vue&type=template&id=b5905e30"
import script from "./DemandsTable.vue?vue&type=script&lang=js"
export * from "./DemandsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports